module.exports = __webpack_public_path__ + "img/12.3.TP.4e13d023.png";